import ctl from '@netlify/classnames-template-literals';

export const companyDetailsContainer = ctl(`
    border-[1px]
    border-azureish-white
    shadow-cetacean-blue
    overflow-hidden
    rounded-md  
    mb-3
  `);

export const companyDetailsContainerTitle = ctl(`
    border-b-[1px] 
    bg-ghost-white 
    border-azureish-white 
    font-[600]
    p-2
   `);

export const companyRegistrationContainer = ctl(`
   bg-ghost-white 
   border-azureish-white 
   font-[600]
   p-2
   rounded-md
   border-[1px]
   mb-3
   flex
   justify-between
 `);

export const buttonStyle = ctl(`
  px-4
  py-1
  mt-2
  ml-2
  rounded-xl
  bg-gunmetal
  text-anti-flash-white
  cursor-pointer
`);

export const form = 'p-4 bg-white';

export const redButton = 'text-red-500';
